export const DEALER_OPTIONS_ARCHIVE_PERIOD = [
  "id",
  "code",
  "DealerName",
  "INN",
  "idPeriod",
  "dateStart",
  "dateEnd",
];
